module.exports = __webpack_public_path__ + "static/media/class_mobile.823dda03.png";